import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
    fill: '#7df3e1',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 24"
    >
      <path d="M7.78724 21.9036L0 0.872192H4.57438L10.8205 18.4055L17.0349 0.872192H21.6752L13.8254 21.9115C13.3572 23.1673 12.1536 23.9999 10.808 23.9999C9.46016 23.9999 8.25434 23.1628 7.78838 21.9036H7.78724Z" />
    </svg>
  );
};
